export function getLoginErrorMessage(): string | null {
  const params = new URLSearchParams(window.location.search)
  if (params.get('error') === 'unauthorized') {
    return 'You are not allowed to access this app. Please contact your administrator.'
  }
  return null
}
